import React from 'react';
import codingQueueIcon  from "../../../common/assets/images/coding_queue.png";
import auditsGreenIcon  from "../../../common/assets/images/audits_green.png";
import cdqsIcon  from "../../../common/assets/images/cdqs_icon.png";
import outstandingTasksNew  from "../../../common/assets/images/outstanding_tasks_new.png";
import "./Coding.css";
import BellIcon from "../../../common/assets/images/no_messages_bell_icon.png";
import { Accordion } from "react-bootstrap";

const Coding = () => {
  const codingDashboardOptions = [
    {name: "Coding Queue", icon: codingQueueIcon, count: 12},
    {name: "Audits", icon: auditsGreenIcon, count: 6},
    {name: "CDQs for Review", icon: cdqsIcon, count: 0},
    {name: "Outstanding Tasks", icon: outstandingTasksNew, count: 196},
  ];

  const codingAllocationOptions = {
    allocationHeader: "Coding Allocation", 
    unassignedEpisodesOptions : [
        {name: "Unassigned Episodes", count: 196}
      ],
      auditHeader: "Audit Allocation", 
      auditAllocationOptions : [
        {name: "Unassigned Audit Episodes", count: 63}
      ],
      snapshotHeader: "Snapshot", 
      snapshotOptions : [
        {name: "Uncoded Episodes", count: 256},
        {name: "Episodes Coded Today", count: 78},
        {name: "Episodes Audited Today", count: 16},
      ],
    }

    const auditingData = [
      {
        headingName: "ABF and NWAU Optimisation",
        key: "1",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        headingName: "ICD-10-AM and ACHI",
        key: "2",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        headingName: "Coding Quality Assurance",
        key: "3",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        headingName: "DRGs, Error DRGs",
        key: "4",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        headingName: "Clinical Speciality",
        key: "5",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        headingName: "My Audits",
        key: "6",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
    ];


    const reportingData = [
      {
        headingName: "Outstanding Coding",
        key: "1",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        headingName: "Error DRGs",
        key: "2",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        headingName: "ABF and NWAU Optimisation",
        key: "3",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        headingName: "Hospital Acquired Complications (HACs)",
        key: "4",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        headingName: "Outliers",
        key: "5",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        headingName: "Audit Results",
        key: "6",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        headingName: "Coding Errors and Edits",
        key: "7",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        headingName: "Clinical Documentation Queries (CDQs)",
        key: "8",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        headingName: "Coding KPIs",
        key: "9",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
      {
        headingName: "Performance",
        key: "10",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      },
    ];
  return (
    <div className='workflow-coding-container'>
      <div className='coding-dashboard'>
        {codingDashboardOptions.map((dashboardItem) => (
          <div key={dashboardItem.name} className='coding-dashboard-cards'>
            <p className='coding-dashboard-icon'><img src={dashboardItem.icon} alt={dashboardItem.name} /></p>
            <p className='coding-dashboard-count'>{dashboardItem.count}</p>
            <p className='coding-dashboard-name'>{dashboardItem.name}</p>
          </div>
        ))}
      </div>
      <div className='coding-section-subcards'>
        <div className='coding-task-allocation'>
          <p className='coding-task-allocation-header'>Task Allocation</p>
          <div className='coding-allocation-card-section'>
            <p className='coding-allocation-card-header'>{codingAllocationOptions.allocationHeader}</p>
            {
              codingAllocationOptions.unassignedEpisodesOptions.map((item) => (
                <div key={item.name} className='coding-allocation-card'>
                  <p className='coding-allocation-card-name'>{item.name}</p>
                  <p className='coding-allocation-card-count'>{item.count}</p>
                </div>
              ))
            }
          </div>
          <div className='audit-allocation-card-section'>
          <p className='audit-allocation-card-header'>{codingAllocationOptions.auditHeader}</p>
            {
              codingAllocationOptions.auditAllocationOptions.map((item) => (
                <div key={item.name} className='audit-allocation-card'>
                  <p className='audit-allocation-card-name'>{item.name}</p>
                  <p className='audit-allocation-card-count'>{item.count}</p>
                </div>
              ))
            }
          </div>
          <div className='snapshot-card-section'>
          <p className='snapshot-card-header'>{codingAllocationOptions.snapshotHeader}</p>
            {
              codingAllocationOptions.snapshotOptions.map((item) => (
                <div key={item.name} className='snapshot-card'>
                  <p className='snapshot-card-name'>{item.name}</p>
                  <p className='snapshot-card-count'>{item.count}</p>
                </div>
              ))
            }
          </div>
        </div>
        <div className='coding-auditing'>
        <p className='coding-auditing-header'>Auditing</p>
             {auditingData.map((auditingItem) => (
                        <Accordion
                          defaultActiveKey="1"
                          className="coding-auditing-accordion-section"
                          key={auditingItem.key}
                        >
                          <Accordion.Item
                            eventKey={auditingItem.key}
                            className="auditing-accordionItem-section"
                          >
                            <Accordion.Header className="coding-auditing-accordionHeader-section">
                              {auditingItem.headingName}
                            </Accordion.Header>
                            <Accordion.Body className="auditing-accordionBody-section">
                              {auditingItem.body}
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      ))}

        </div>
        <div className='coding-reporting'>
        <p className='coding-reporting-header'>Reporting</p>
        {reportingData.map((auditingItem) => (
                        <Accordion
                          defaultActiveKey="1"
                          className="coding-auditing-accordion-section"
                          key={auditingItem.key}
                        >
                          <Accordion.Item
                            eventKey={auditingItem.key}
                            className="auditing-accordionItem-section"
                          >
                            <Accordion.Header className="coding-auditing-accordionHeader-section">
                              {auditingItem.headingName}
                            </Accordion.Header>
                            <Accordion.Body className="auditing-accordionBody-section">
                              {auditingItem.body}
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      ))}
        </div>
      </div>
      <div className='coding-message-section'>
            <div className='coding-message-top-section'>
                  <p className='coding-message-header'>Messages</p>
                  <button className='coding-message-btn'>View All</button>
            </div>
            <div className='coding-no-message-section'>
              <img src={BellIcon} alt='no messages' className='coding-no-message-icon'/>
              <span className='coding-no-message-text'>No Messages</span>
            </div>
      </div>
    </div>
  )
}

export default Coding